import { addToUserActions } from '../stored/UserActions';

class ATInternetService {
	sendPage(info) {

		// @ts-ignore
		const { tag } = window;
		if (tag) {
			tag.page.set(info);
			tag.dispatch();
		}
	}

	sendClick(page, info) {
		info.chapter1 = 'klokhuis-scanner';
		info.chapter2 = page;
		info.level2 = '14'
		info.type = info.type ?? 'action';

		// @ts-ignore
		const { tag } = window;
		if (tag) {
			tag.click.send(info);
		}

		addToUserActions([info.chapter2, info.chapter3, info.name].filter(e => e).join(':'), info);
	}
}
export const tag = new ATInternetService();
